<template>
  <div
    class="community-page container"
    :class="{ free: currentPageInfo.type === 'libre' }"
  >
    <div
      v-if="loadingStore.isLoading"
      class="pending"
    />
    <div
      v-else
      class="loading-completed"
    >
      <TheBreadcrumb :pages="arianeRoute" />
      <HeaderCommunityFull :page="currentPageInfo" />
      <div
        v-if="currentPageInfo.type !== 'libre'"
        class="normal"
      >
        <section class="inner-nav">
          <ul>
            <li
              v-if="opinions.length"
              @click="scrollMeTo(opinionsRef)"
            >
              L'avis des joueurs
            </li>
            <li
              v-if="wapers.length"
              @click="scrollMeTo(wapersRef)"
            >
              Les Wapers influents
            </li>
            <li
              v-if="actualities.length"
              @click="scrollMeTo(actualitiesRef)"
            >
              L'actualité
            </li>
            <li
              v-if="tricks.length"
              @click="scrollMeTo(tricksRef)"
            >
              Les astuces
            </li>
            <li
              v-if="medias.length"
              @click="scrollMeTo(mediasRef)"
            >
              L'avis des médias
            </li>
            <li
              v-if="waperCorners.length"
              @click="scrollMeTo(waperCornersRef)"
            >
              Le feed des players
            </li>
          </ul>
        </section>
        <div
          v-if="(communityStats && opinions.length) || wapers.length"
          class="dark-section1 dark-section"
        >
          <section
            v-if="communityStats && opinions.length"
            ref="opinionsRef"
            class="waper-opinion"
          >
            <div class="bazar-voice">
              <p class="dark">Avis authentiques</p>
              <div class="light">
                <img
                  src="~assets/icons/bazarvoice.svg"
                  alt="bazar voice"
                />
              </div>
            </div>
            <div class="title-line line">
              <h2 class="title-strat">
                L'avis des joueurs {{ currentPageInfo.title }}
              </h2>
            </div>
            <HeaderBazarVoice :community="communityStats" />
          </section>
          <section
            v-if="opinions.length"
            class="waper-opinion-slider section white"
          >
            <div class="title-line line">
              <h3 class="hide">avis joueurs</h3>
              <NuxtLink
                :to="`/communautes/${slug}/avis-joueurs`"
                class="button-more"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 19.328 34.43"
                >
                  <path
                    d="M165.21-130.78l-15.05-15.1a2.178,2.178,0,0,0-3.041,0,2.178,2.178,0,0,0,0,3.041l13.555,13.555L147.119-115.73a2.178,2.178,0,0,0,0,3.041,2.178,2.178,0,0,0,3.041,0l15.05-15.05A2.178,2.178,0,0,0,165.21-130.78Z"
                    transform="translate(-146.5 146.5)"
                    fill="#FFFFFF"
                    fill-rule="evenodd"
                  />
                </svg>
                Voir tous les avis de joueurs
              </NuxtLink>
            </div>
            <div class="slider">
              <CardSlider :cards="opinions" />
            </div>
          </section>
          <div
            v-if="opinions.length"
            class="separator-line"
          >
            <div class="separator" />
            <ButtonPoint
              :points="referentialStore.referential?.points.post_review_create"
              class="button-point"
              label="Ajouter un avis"
              @click="addReview()"
            />
          </div>
          <section
            v-if="wapers.length"
            ref="wapersRef"
            class="top-wapers section white"
          >
            <div class="title-line line">
              <h2 class="title-strat">
                Les wapers les plus influents de la communauté
                {{ currentPageInfo.title }}
              </h2>
              <NuxtLink
                :to="`/communautes/${slug}/wapers`"
                class="button-more"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 19.328 34.43"
                >
                  <path
                    d="M165.21-130.78l-15.05-15.1a2.178,2.178,0,0,0-3.041,0,2.178,2.178,0,0,0,0,3.041l13.555,13.555L147.119-115.73a2.178,2.178,0,0,0,0,3.041,2.178,2.178,0,0,0,3.041,0l15.05-15.05A2.178,2.178,0,0,0,165.21-130.78Z"
                    transform="translate(-146.5 146.5)"
                    fill="#FFFFFF"
                    fill-rule="evenodd"
                  />
                </svg>
                Plus de Wapers
              </NuxtLink>
            </div>
            <div class="slider">
              <WaperSlider
                :wapers="wapers"
                :nb-lines="1"
              />
            </div>
          </section>
        </div>
        <div ref="actualitiesRef">
          <CardSection
            v-if="actualities.length"
            class="actu-community"
            :title="`L’actualité ${currentPageInfo.title}`"
            cta-label="Plus d'actualités"
            :cta-route="`/communautes/${slug}/actualites-communaute`"
            :cards="actualities"
          />
        </div>
        <BlueSection
          :connected="authenticated"
          diagonal="top white"
          :challenges="challenges"
          class="blue-section-item"
        />
        <div
          v-if="tricks.length"
          ref="tricksRef"
          class="dark-section dark-section2"
        >
          <CardSection
            class="tricks"
            :title="`Les astuces ${currentPageInfo.title}`"
            cta-label="Plus d'astuces"
            :cta-route="`/communautes/${slug}/astuces`"
            :cards="tricks"
            color="white"
          />
        </div>
        <div ref="mediasRef">
          <CardSection
            v-if="medias.length"
            class="medias-section"
            :title="`L'avis des médias sur ${currentPageInfo.title}`"
            cta-label="Plus d'avis des médias"
            :cta-route="`/communautes/${slug}/avis-medias`"
            :cards="medias"
          />
        </div>
        <div ref="waperCornersRef">
          <CardSection
            v-if="waperCorners.length"
            class="waper-corner-section"
            :title="`le feed des players ${currentPageInfo.title}`"
            cta-label="Plus de contenus Players"
            :cta-route="`/communautes/${slug}/le-feed-des-players`"
            :cards="waperCorners"
          />
        </div>
      </div>
      <div
        v-else
        class="free-content"
      >
        <section class="inner-nav">
          <ul>
            <li
              v-if="actualities.length"
              @click="scrollMeTo(actualitiesRef)"
            >
              L'actualité
            </li>
            <li
              v-if="waperCorners.length"
              @click="scrollMeTo(waperCornersRef)"
            >
              Le feed des players
            </li>
            <li
              v-if="wapers.length"
              @click="scrollMeTo(wapersRef)"
            >
              Les Wapers influents
            </li>
          </ul>
        </section>
        <div ref="actualitiesRef">
          <CardSection
            v-if="actualities.length"
            class="actu-community"
            :title="`L’actualité ${currentPageInfo.title}`"
            cta-label="Plus d'actualités"
            :cta-route="`/communautes/${slug}/actualites-communaute`"
            :cards="actualities"
          />
        </div>
        <div ref="waperCornersRef">
          <CardSection
            v-if="waperCorners.length"
            class="waper-corner-section"
            :title="`le feed des players ${currentPageInfo.title}`"
            cta-label="Plus de contenus Players"
            :cta-route="`/communautes/${slug}/le-feed-des-players`"
            :cards="waperCorners"
          />
        </div>
        <div
          v-if="wapers.length"
          class="dark-section3 dark-section"
        >
          <section
            ref="wapersRef"
            class="top-wapers section white"
          >
            <div class="title-line line">
              <h2 class="title-strat">
                Les wapers les plus influents de la communauté
                {{ currentPageInfo.title }}
              </h2>
              <NuxtLink
                :to="`/communautes/${slug}/wapers`"
                class="button-more"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 19.328 34.43"
                >
                  <path
                    d="M165.21-130.78l-15.05-15.1a2.178,2.178,0,0,0-3.041,0,2.178,2.178,0,0,0,0,3.041l13.555,13.555L147.119-115.73a2.178,2.178,0,0,0,0,3.041,2.178,2.178,0,0,0,3.041,0l15.05-15.05A2.178,2.178,0,0,0,165.21-130.78Z"
                    transform="translate(-146.5 146.5)"
                    fill="#FFFFFF"
                    fill-rule="evenodd"
                  />
                </svg>
                Plus de Wapers
              </NuxtLink>
            </div>
            <div class="slider">
              <WaperSlider
                :wapers="wapers"
                :nb-lines="1"
              />
            </div>
          </section>
        </div>
        <BlueSection
          :connected="authenticated"
          diagonal="top dark"
          :challenges="challenges"
          class="blue-section-item"
        />
      </div>
      <DoNotMissSection
        v-if="doNotMiss.length"
        :slider-items="doNotMiss"
      />
      <OfferSection
        v-if="offer"
        :offer="offer"
      >
        Acheter ce jeu
      </OfferSection>
      <section
        v-if="otherCommunities.length"
        class="other-communities section"
      >
        <div class="title-line line">
          <h2 class="title-strat">ces communautés peuvent vous intéresser</h2>
          <NuxtLink
            to="/communautes"
            class="button-more"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 19.328 34.43"
            >
              <path
                d="M18.71 15.72 3.66.62a2.178 2.178 0 0 0-3.041 0 2.178 2.178 0 0 0 0 3.041l13.555 13.555L.619 30.77a2.178 2.178 0 0 0 0 3.041 2.178 2.178 0 0 0 3.041 0l15.05-15.05a2.178 2.178 0 0 0 0-3.041Z"
                fill="#fff"
                fill-rule="evenodd"
              />
            </svg>
            <h3>Plus de communautés</h3>
          </NuxtLink>
        </div>
        <div class="slider">
          <CommunitySlider :communities="otherCommunities" />
        </div>
      </section>
      <p class="mention">
        * Récompense provisoire sous réserve de maintenir votre place au
        classement jusqu'à la fin du mois.
      </p>
      <PegiWarning v-if="community?.pegi === '18'" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { useLoadCommunity } from '~/composables/useLoadCommunity'
import { setContributionModalTab } from '~/modals/contribution'
import { useLoadingStore } from '~/stores/loading'
import type { CommunityPageInfo, CommunityStats } from '~/types'

definePageMeta({
  middleware: (to) => {
    const loadCommunity = useLoadCommunity()
    return loadCommunity(to)
  },
})

const arianeRoute = computed(() => {
  return [
    {
      title: 'Toutes les communautés',
      route: '/communautes',
    },
    {
      title: community.value ? community.value.title : '',
      route: '',
    },
  ]
})

const breadcrumbSchema = useBreadcrumbSchema({
  arianeRoute,
})

const communitiesStore = useCommunitiesStore()
const { community } = storeToRefs(communitiesStore)

const communitySchema = useCommunitySchema(community)

useHead({
  title: community.value?.title_seo,
  script: [communitySchema, breadcrumbSchema],
})

useSeoMeta({
  title: community.value?.title_seo,
  description: community.value?.description_seo,
  keywords: community.value?.keywords_seo,
  ogTitle: community.value?.title_og,
  ogDescription: community.value?.description_og,
  ogImage:
    community.value?.image_og?.url ??
    'https://www.weareplaystation.fr/img/og-img.jpg',
})

const referentialStore = useReferentialStore()

const loadingStore = useLoadingStore()

const challengesStore = useChallengesStore()
const { challenges } = storeToRefs(challengesStore)

const slidersStore = useDoNotMissStore()
const { doNotMiss } = storeToRefs(slidersStore)

const route = useRoute()

const slug = computed(() => {
  return route.params.communityName as string
})

const currentPageInfo = computed(() => {
  const rawCommunity = unref(community)
  const details = []
  const consoles = rawCommunity?.consoles?.map((item) => item.name) || []
  const gameTypes = rawCommunity?.game_types || []

  if (consoles.length) {
    details.push({
      label: 'Console',
      value: consoles.join(', '),
    })
  }

  if (gameTypes.length) {
    details.push({
      label: 'Genre',
      links: gameTypes,
    })
  }

  if (rawCommunity?.launched_at) {
    details.push({
      label: 'Date de sortie',
      value: dateToString(rawCommunity.launched_at),
    })
  }

  if (rawCommunity?.editor) {
    details.push({
      label: 'Éditeur',
      value: rawCommunity.editor,
    })
  }

  let percentReco: number | undefined
  let opinionsCount: number | undefined
  let score: number | undefined

  if (rawCommunity?.stats) {
    percentReco = rawCommunity.stats.recommendations_percent
    opinionsCount = rawCommunity.stats.total_review
    score = rawCommunity.stats.rating
  }

  const { image, imageMobile } = getImages(rawCommunity)

  return {
    game: rawCommunity?.title,
    image,
    imageMobile,
    description: rawCommunity?.description,
    title: rawCommunity?.title,
    video: rawCommunity?.video,
    type: rawCommunity?.type?.slug,
    pegi: rawCommunity?.pegi,
    score,
    opinionsCount,
    slug: slug.value,
    percentReco,
    details,
    members: rawCommunity?.users_count,
    contribPoints: referentialStore.referential?.points.post_source_create,
    follow: rawCommunity?.is_following,
    showReview: !!communityStats.value && !!opinions.value.length,
  } satisfies CommunityPageInfo
})

const offer = computed(() => {
  if (!community.value?.content_blocks) return undefined

  const contentBlock = community.value.content_blocks.find(
    (contentBlock) =>
      contentBlock?.content_block_type?.slug === 'offres-du-moment',
  )

  const firstOffer = contentBlock?.content_block_type?.offers?.[0]

  if (!firstOffer) return undefined

  return { ...firstOffer, route: `/offres/${firstOffer.slug}` }
})

const communityStats = computed(() => {
  const rawCommunity = unref(community)

  if (!rawCommunity?.stats) return undefined

  const categories = []

  if (rawCommunity.stats.rating_graph > 0) {
    categories.push({
      title: 'Graphisme',
      score: rawCommunity.stats.rating_graph,
    })
  }
  if (rawCommunity.stats.rating_gaming > 0) {
    categories.push({
      title: 'Jouabilité',
      score: rawCommunity.stats.rating_gaming,
    })
  }
  if (rawCommunity.stats.rating_life > 0) {
    categories.push({
      title: 'Durée de vie',
      score: rawCommunity.stats.rating_life,
    })
  }
  if (rawCommunity.stats.rating_design > 0) {
    categories.push({
      title: 'Design',
      score: rawCommunity.stats.rating_design,
    })
  }

  const scores = rawCommunity.stats.rating_distribution_percent && [
    {
      score: 5,
      percent: rawCommunity.stats.rating_distribution_percent['5'],
    },
    {
      score: 4,
      percent: rawCommunity.stats.rating_distribution_percent['4'],
    },
    {
      score: 3,
      percent: rawCommunity.stats.rating_distribution_percent['3'],
    },
    {
      score: 2,
      percent: rawCommunity.stats.rating_distribution_percent['2'],
    },
    {
      score: 1,
      percent: rawCommunity.stats.rating_distribution_percent['1'],
    },
  ]

  return {
    recommendation: rawCommunity.stats.recommendations_percent,
    totalScore: rawCommunity.stats.rating,
    scores,
    categories,
    total_review: rawCommunity.stats.total_review,
    slug: rawCommunity.slug,
    communityType: rawCommunity.type?.slug,
  } satisfies CommunityStats
})

const opinions = computed(() => {
  if (!community.value?.content_blocks) return []

  const postsBlock = community.value.content_blocks
    .map((item) => {
      return item['content_block_type']
    })
    .find((block) => block?.slug === 'avis-joueurs')

  if (!postsBlock?.post_reviews?.length) return []

  return postsBlock.post_reviews.map((item) => ({
    ...item,
    route: `/communautes/${slug.value}/avis-joueurs/detail/${item.slug}`,
  }))
})

const wapers = computed(() => {
  if (!community.value?.content_blocks?.length) return []

  const usersBlock = community.value.content_blocks
    .map((item) => item['content_block_type'])
    .find((block) => block?.slug === 'wapers')

  if (!usersBlock?.users?.length) return []

  return usersBlock.users.map((item) => ({
    ...item.user,
    route: `/wapers/${item.user.slug}`,
  }))
})

const actualities = computed(() => {
  if (!community.value?.content_blocks?.length) return []

  const postsBlock = community.value.content_blocks
    .map((item) => item['content_block_type'])
    .find((block) => block?.slug === 'actualites-communaute')

  if (!postsBlock?.posts?.length) return []

  return postsBlock.posts.map((item) => ({
    ...item,
    route: `/communautes/${slug.value}/actualites-communaute/${item.slug}`,
  }))
})

const tricks = computed(() => {
  if (!community.value?.content_blocks?.length) return []

  const postsBlock = community.value.content_blocks
    .map((item) => item['content_block_type'])
    .find((block) => block?.slug === 'astuces')

  if (!postsBlock?.posts?.length) return []

  return postsBlock.posts.map((item) => {
    const subCategorySlug = item.sub_category?.slug ?? 'temporaire'

    return {
      ...item,
      route: `/communautes/${slug.value}/astuces/${subCategorySlug}/${item.slug}`,
    }
  })
})

const medias = computed(() => {
  if (!community.value?.content_blocks?.length) return []

  const postsBlock = community.value.content_blocks
    .map((item) => item['content_block_type'])
    .find((block) => block?.slug === 'avis-medias')

  if (!postsBlock?.posts?.length) return []

  return postsBlock.posts.map((item) => ({
    ...item,
    route: `/communautes/${slug.value}/avis-medias/${item.slug}`,
  }))
})

const otherCommunities = computed(() => {
  if (!community.value?.content_blocks?.length) return []

  const communityBlock = community.value.content_blocks
    .map((item) => item['content_block_type'])
    .find((block) => block?.slug === 'communautes')

  if (!communityBlock?.communities?.length) return []

  return communityBlock.communities.map((item) => ({
    ...item,
    route: `/communautes/${item.slug}`,
  }))
})

const waperCorners = computed(() => {
  if (!community.value?.content_blocks?.length) return []

  const postsBlock = community.value.content_blocks
    .map((item) => item['content_block_type'])
    .find((block) => block?.slug === 'le-coin-des-wapers')

  if (!postsBlock?.posts?.length) return []

  return postsBlock.posts.map((item) => {
    const subCategorySlug = item.sub_category?.slug ?? 'temporaire'

    return {
      ...item,
      route: `/communautes/${slug.value}/le-feed-des-players/${subCategorySlug}/${item.slug}`,
    }
  })
})

const addReview = async () => {
  track('cta', {
    cta_name: 'Ajouter un avis',
  })
  if (!authenticated.value) {
    const { loginModal } = await import('~/modals/login')
    return loginModal.open()
  }

  setContributionModalTab('review')
  const { contributionModal } = await import('~/modals/contribution')
  return contributionModal.open()
}

const { authenticated } = useAuthenticated()
const loadCommunity = useLoadCommunity()

watch(authenticated, (newValue) => {
  if (newValue) {
    loadCommunity(route)
  }
})

const opinionsRef = ref<HTMLElement | null>(null)
const wapersRef = ref<HTMLElement | null>(null)
const actualitiesRef = ref<HTMLElement | null>(null)
const tricksRef = ref<HTMLElement | null>(null)
const mediasRef = ref<HTMLElement | null>(null)
const waperCornersRef = ref<HTMLElement | null>(null)

const scrollMeTo = (refInstance: HTMLElement | null) => {
  refInstance?.scrollIntoView({ behavior: 'smooth', block: 'center' })
}
</script>
<style lang="scss" scoped>
.community-page {
  min-height: 100vh;

  .hide {
    opacity: 0;
  }

  &.free {
    .blue-section-item {
      margin-top: 0;
    }

    .free-content {
      position: relative;
      margin: 0;
      padding: 0;

      .inner-nav {
        padding-bottom: 0;

        ul {
          justify-content: flex-start;
        }
      }

      .dark-section {
        padding-top: 11rem;
        padding-bottom: 8rem;
      }

      .waper-corner-section {
        margin-bottom: -11rem;
      }

      .blue-section {
        margin-top: 0;

        &::after {
          border-color: $darkBackground transparent transparent transparent;
        }
      }
    }
  }

  .inner-nav {
    padding: 3rem 0 5rem;
    overflow-x: auto;

    ul {
      display: block;
      margin-left: 0;
      padding-left: 4rem;
      white-space: nowrap;
      list-style-type: none;

      li {
        display: inline-block;
        flex-shrink: 0;
        height: 7.4rem;
        padding: 0 4rem;
        font-size: 1.6rem;
        line-height: 7.4rem;
        border-right: 1px solid rgba(#013d7b, 0.3);
        cursor: pointer;

        &:last-child {
          border-right: none;
        }
      }
    }
  }

  .blue-section-item {
    margin-top: 5rem;
  }

  .dark-section1 {
    position: relative;
    padding-bottom: 8rem;

    .waper-opinion {
      padding-top: 8rem;

      .bazar-voice {
        top: 0;
        bottom: auto;
      }

      .title-line {
        margin-bottom: 4.4rem;
        padding-left: 8rem;
      }

      .header-bazar-voice {
        padding-top: 0;
        padding-bottom: 0;
      }
    }

    .separator-line {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 5rem;
      padding: 0 8rem;

      .separator {
        flex-grow: 1;
        height: 1px;
        margin-right: 12rem;
        background: $white;
        opacity: 0.2;
      }

      .button-point {
        flex-shrink: 0;
      }
    }

    .top-wapers {
      margin-top: 0;
      padding-top: 5rem;
    }
  }

  .dark-section2 {
    padding: 8rem 0;

    .tricks {
      margin-top: 0;
    }
  }

  .mention {
    margin-top: 10rem;
  }
}

@media screen and (min-width: 2000px) {
  .community-page {
    .inner-nav {
      max-width: 200rem;
      margin-right: auto;
      margin-left: auto;
    }

    .dark-section {
      .waper-opinion {
        max-width: 200rem;
        margin-right: auto;
        margin-left: auto;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .community-page {
    .waper-opinion-slider {
      margin-top: 0;
    }
  }
}

@media screen and (max-width: 700px) {
  .community-page {
    .waper-opinion-slider {
      padding-right: 0;
      padding-left: 0;

      .title-line {
        margin-top: 3rem;
        margin-bottom: 3rem;
      }
    }

    .inner-nav {
      padding-right: 0;
      padding-left: 0;

      ul {
        display: block;
        padding-left: 0;
        white-space: nowrap;

        li {
          display: inline-block;
          padding: 0 2.5rem;
        }
      }
    }

    .dark-section {
      .title-line {
        padding: 0 2.5rem !important;
      }
    }

    .other-communities,
    .card-section,
    .top-wapers {
      padding-right: 0;
      padding-left: 0;
    }
  }
}

@media screen and (max-width: 500px) {
  .container {
    .dark-section {
      .separator-line {
        margin-top: 5rem;
        padding: 0 2.5rem;

        .separator {
          display: none;
        }
      }
    }
  }
}
</style>
